<template>
    <div>

        <DxPopup
                :visible="popupVisible"
                :drag-enabled="false"
                :hide-on-outside-click="true"
                :show-close-button="false"
                :show-title="true"
                :width="300"
                :height="280"
                container=".dx-viewport"
                title="弹出框"
        >
            <DxPosition
                    my="center"
                    v-model:of="positionOf"
            />
            <DxToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="before"
                    :options="emailButtonOptions"
            />
            <DxToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    :options="closeButtonOptions"
            />
           <div class="message_style">
               <!--提示文本-->
               {{msg}}
           </div>
        </DxPopup>
    </div>
</template>

<script>
    export default {
        name: "enquire-box",

        props:{
            popupVisible:Boolean,
            title:String,
            msg:String,
        },

        data(){
            return{
                positionOf: '',
                emailButtonOptions: {
                    icon: 'email',
                    text: '确定',
                    onClick: () => {
                        this.$emit("changeEnquire",true)
                    },
                },
                closeButtonOptions: {
                    text: '取消',
                    onClick: () => {
                        this.$emit("changeEnquire",false)
                    },
                },
            }
        },
        methods:{
        }
    }
</script>

<style scoped>
    .message_style{
        width: 100%;
        word-break: break-word;
    }
</style>